export function uid(prefix = 'x') {
  return `${prefix}_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 9)}`;
}

export function msgId() {
  return `m_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 7)}`;
}

export function detectDevice() {
  const ua = navigator.userAgent;
  if (/tablet|ipad|playbook|silk/i.test(ua)) return 'tablet';
  if (/mobile|iphone|ipod|android|blackberry|mini|palm/i.test(ua)) return 'mobile';
  return 'desktop';
}

export function detectBrowser() {
  const ua = navigator.userAgent;
  if (/edg\//i.test(ua))   return 'Edge';
  if (/opr\//i.test(ua))   return 'Opera';
  if (/chrome/i.test(ua))  return 'Chrome';
  if (/safari/i.test(ua))  return 'Safari';
  if (/firefox/i.test(ua)) return 'Firefox';
  if (/trident/i.test(ua)) return 'IE';
  return 'Unknown';
}

export function formatTime(ts, locale = 'en') {
  return new Intl.DateTimeFormat(locale, { hour: '2-digit', minute: '2-digit' }).format(new Date(ts));
}

export function dateLabel(ts, locale = 'en') {
  const d         = new Date(ts);
  const today     = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  const sameDay = (a, b) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth()    === b.getMonth()    &&
    a.getDate()     === b.getDate();
  if (sameDay(d, today))     return 'Today';
  if (sameDay(d, yesterday)) return 'Yesterday';
  return new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long', year: 'numeric' }).format(d);
}
